<template>
  <!-- 第二步：基础设施上云情况 -->
  <div class="secondStep">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="200px"
      class="form-wrap"
      :disabled="!ifEdit"
    >
      <div class="step-title">IT 资源（IT Infrastructure）：</div>
      <el-form-item label="服务器使用(台)" prop="baseService">
        <el-input-number v-model="form.baseService" :min="0" />
      </el-form-item>
      <el-form-item label="使用云存储数据(GB)" prop="baseResource">
        <el-input-number v-model="form.baseResource" :min="0" />
      </el-form-item>
      <el-form-item label="中间件产品类型数量(个)" prop="baseDesk">
        <el-input-number v-model="form.baseDesk" :min="0" />
      </el-form-item>
      <el-form-item label="云数据库使用(台)" prop="baseDatabase">
        <el-input-number v-model="form.baseDatabase" :min="0" />
      </el-form-item>
      <div class="step-title">安全防护（Security）：</div>
      <el-form-item label="使用云数据安全产品(个)" prop="baseSecData">
        <el-input-number v-model="form.baseSecData" :min="0" />
      </el-form-item>
      <el-form-item label="使用云系统安全产品(个)" prop="baseSecSystem">
        <el-input-number v-model="form.baseSecSystem" :min="0" />
      </el-form-item>
      <el-form-item label="使用云网络安全产品(个)" prop="baseSecNet">
        <el-input-number v-model="form.baseSecNet" :min="0" />
      </el-form-item>
      <el-form-item label="其他类型基础上云(类)" prop="baseOther">
        <el-input-number v-model="form.baseOther" :min="0" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { secondSave, secondInfo } from "@/utils/interface";
const form = () => {
  return {
    baseService: "", // 服务器上云数量
    baseDatabase: "", // 数据库上云数量
    baseResource: "", // 存储资源上云数量
    baseDesk: "", // 中间件上云数量
    baseSecData: "", // 数据安全上云数量
    baseSecSystem: "", // 应用安全上云数量
    baseSecNet: "", // 网络安全上云数量
    baseOther: "" // 其他类型基础上云数量
  };
};
export default {
  name: "",
  components: {},
  props: {
    registerId: {
      type: String
    },
    ifEdit: {
      type: Boolean,
      default: false
    } // 是否是可编辑状态，即上云申请只保存未提交,false为不可编辑，true为可编辑
  },
  data() {
    const rules = () => {
      return {
        baseService: [
          { required: true, message: "请输入服务器上云数量", trigger: "blur" }
        ],
        baseDatabase: [
          { required: true, message: "请输入数据库上云数量", trigger: "blur" }
        ],
        baseResource: [
          { required: true, message: "请输入存储资源上云数量", trigger: "blur" }
        ],
        baseDesk: [
          { required: true, message: "请输入中间件上云数量", trigger: "blur" }
        ],
        baseSecData: [
          { required: true, message: "请输入数据安全上云数量", trigger: "blur" }
        ],
        baseSecSystem: [
          { required: true, message: "请输入应用安全上云数量", trigger: "blur" }
        ],
        baseSecNet: [
          { required: true, message: "请输入网络安全上云数量", trigger: "blur" }
        ],
        baseOther: [
          {
            required: true,
            message: "请输入其他类型基础上云数量",
            trigger: "blur"
          }
        ]
      };
    };
    return {
      form: form(),
      rules: rules(),
      uuid: "" // 当前条保存后的uuid
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    if (this.$route.query.uuid) {
      this.getSecondInfo();
    }
  },
  methods: {
    /* 第二步保存 */
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let params = {
            userUuid: this.$store.state.isUsermessage.uuid,
            registerId: this.registerId,
            uuid: this.uuid,
            ...this.form
          };
          secondSave(params).then(res => {
            if (res.success) {
              this.$message({
                message: res.message,
                type: "success"
              });
              this.uuid = res.data.uuid;
              this.$parent.activeStep++;
            } else {
              this.$message({
                message: res.message,
                type: "error"
              });
            }
          });
        }
      });
    },
    /* 第二步详情 */
    getSecondInfo() {
      secondInfo(this.$route.query.uuid).then(res => {
        if (res.success && Object.keys(res.data).length > 0) {
          this.form = res.data;
        } else {
          this.form = form();
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";

.secondStep {
  .step-title {
    position: relative;
    font-size: 14px;
    margin: 20px 0;
    &::before {
      position: absolute;
      content: "";
      width: 4px;
      height: 4px;
      border-radius: 50%;
      .bc();
      top: 50%;
      transform: translateY(-50%);
      left: -10px;
    }
  }
  /deep/ .el-form-item {
    width: 525px;
    margin: 0 auto;
    margin-bottom: 20px;
  }
  /deep/ .el-input-number {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseCloudUp/component/secondStep.vue